import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

export default class homeState extends baseState {
  // 设备状态统计（总/激活/在线/离线 + 比率）
  @observable deviceStats = {};
  @action
  setDeviceStats = data => this.deviceStats = data;
  getDeviceStats = () => {
    return this.fetch({
      url: apiUrl.HOME.DEVICE_STATS,
      method: 'get',
      setState: this.setDeviceStats,
    });
  }

  // 告警情况 + 告警分类（今日/已处理/待处理 + 5类）
  @observable alarmStats = {};
  @action
  setAlarmStats = data => this.alarmStats = data;
  getAlarmStats = () => {
    return this.fetch({
      url: apiUrl.HOME.ALARM_STATS,
      method: 'get',
      setState: this.setAlarmStats,
    });
  }

  // 当日告警事件列表
  @observable alarmEvents = [];
  @action
  setAlarmEvents = data => this.alarmEvents = data;
  getTodayAlarms = () => {
    return this.fetch({
      url: apiUrl.HOME.TODAY_ALARMS,
      method: 'get',
      setState: this.setAlarmEvents,
    });
  }

  // 地图设备/告警点位（7类）
  @observable devicePoints = {};
  @action
  setDevicePoints = data => this.devicePoints = data;
  getDevices = () => {
    return this.fetch({
      url: apiUrl.HOME.DEVICES,
      method: 'get',
      setState: this.setDevicePoints,
    });
  }

  // 地图中心点（经纬度 + 5km半径内设备数）
  @observable mapCenter = {};
  @action
  setMapCenter = data => this.mapCenter = data;
  getMapCenter = () => {
    return this.fetch({
      url: apiUrl.HOME.MAP_CENTER,
      method: 'get',
      setState: this.setMapCenter,
    });
  }
}
